import { MDBAlert, MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import { MINUTOS, TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes";

export default class TipoSolicitudFormulario extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                nombre: '',
                descripcion: '',
                horas: 0,
                minutos: 0,
                departamento_area: 0,
            },
            colapsar: true,
            camposRequeridos: [],
            departamentoArea: [],
        };
        this.colapsar = this.colapsar.bind(this);
    }

    componentDidMount() {
        const { registro } = this.state;
        for (const llave in registro) {
            if (registro[llave] === null) {
                registro[llave] = "";
            }
        }
        this.obtenerDepartamentos();
    }

    obtenerDepartamentos(){
        this.apiRest.get('/departamentoArea').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentoArea: resultado.data} );
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    almacenarRegistro = () => {
        if (this.datosRegistroValidos()) {
            const registro = this.state.registro
            if (_valid(registro.id)) {
                this.apiRest.put('/tipoSolicitud/' + registro.id, registro).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.props.history.replace('/tipoSolicitudListado');
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            } else {
                this.apiRest.post('/tipoSolicitud', registro).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.props.history.replace('/tipoSolicitudListado');
                        this.setState({ registro: resultado.data })
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            }
        }
    }

    datosRegistroValidos() {
        const { camposRequeridos } = this.state;
        const { nombre, horas, minutos, departamento_area } = this.state.registro;
        if (!_valid(nombre)) {
            camposRequeridos.push("Nombre");
        }
        if (!_valid(parseInt(horas))) { // Ingresa si el campo horas tiene "0"
            if (!_valid(parseInt(minutos))) {
                camposRequeridos.push("El tiempo (horas o minutos)");
            }
        }
        if (!_valid(parseInt(departamento_area))) {
            camposRequeridos.push("Departamento - área");
        }
        
        if(_valid(camposRequeridos)){
            this.setState({ camposRequeridos: camposRequeridos });
            setTimeout(() => this.setState({ camposRequeridos: [] }), TIEMPO_MOSTRAR_ERROR);
            return false;
        }
        return true;
    }

    render() {
        const { registro, colapsar, camposRequeridos, departamentoArea } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Datos" breadcrumbItem="Tipo de solicitud" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Tipo de solicitud</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <div>
                                                        <Row>
                                                            <Col lg={6}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="nombre" className="form-label">
                                                                        Nombre del tipo
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.nombre}
                                                                        onChange={this.actualizarValores}
                                                                        name="nombre"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresar nombre del tipo"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={12}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="nombre" className="form-label">
                                                                        Descripción
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.descripcion}
                                                                        onChange={this.actualizarValores}
                                                                        name="descripcion"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresar descripcion"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={6}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="horas" className="form-label">
                                                                        Horas
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.horas}
                                                                        onChange={this.actualizarValores}
                                                                        name="horas"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresar horas"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={6}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="minutos" className="form-label">
                                                                        Minutos
                                                                    </Label>
                                                                    <select
                                                                        value={registro.minutos}
                                                                        onChange={this.actualizarValores}
                                                                        name="minutos"
                                                                        className="form-control"
                                                                    >
                                                                        {MINUTOS.map(min => <option key={min.value} value={min.value}>{min.label}</option>)}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                            <Col lg={12}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="departamento_area" className="form-label">
                                                                        Departamento - área
                                                                    </Label>
                                                                    <select
                                                                        value={registro.departamento_area}
                                                                        onChange={this.actualizarValores}
                                                                        name="departamento_area"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">Seleccionar</option>
                                                                        {departamentoArea.map(depa => <option value={depa.id} key={depa.id}>{depa.nombre}</option>)}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    &nbsp;
                                                    <Row>
                                                        {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                                    </Row>
                                                </Form>
                                            </div>
                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect"color="danger" onClick={() => { this.props.history.replace('/tipoSolicitudListado') }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect"color="success" onClick={() => this.almacenarRegistro()}>
                                                        <MDBIcon icon="fas fa-user-check" /> {' '}
                                                        Listo
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}